module.exports = __webpack_public_path__ + "static/img/logo_footer.bb4b896a.svg";